module.exports = __webpack_public_path__ + "assets/img/7d6686b4ea8b90a6edb01cc7e36750ac.svg";